import { Component, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { LanguageService } from '../../../../core/services/language.service';
import { OptionTranslateService } from '../../../../shared/services/option-translate.service';

import { SHARED_COMPONENTS } from '../../../../shared/shared-imports';
import { TranslateModule } from '@ngx-translate/core';
import { Utils } from '../../../../Utils/utils';
import { RoutesPath } from '../../../../shared/constants/routes-path';
import { LookupKey } from '../../../../shared/constants/lookup-keys';
import { SharedService } from '../../../../shared/services/shared.service';
import { DocumentServiceType, FieldValue, ServiceName, ServiceNameEn, SrActionType, SrIOName, UserType } from '../../../../shared/constants/services.enum';
import { ApiEndPoints, ApiRoot } from '../../../../shared/constants/api-endpoints';
import { ApiService } from '../../../../core/services/api.service';
import { CommonSrRequest, SiebelMessage } from '../../../../shared/models/services-request/common.model';
import { InformationServiceModel } from '../../../../shared/models/services-request/information.model';
import { debounceTime, distinctUntilChanged, filter, finalize, merge, Subject, Subscription, switchMap, tap } from 'rxjs';
import { SrSubmitSuccessModalComponent } from "../../../../shared/components/sr-submit-success-modal/sr-submit-success-modal.component";
import { SrStatus } from '../../../../shared/constants/status.enum';
import { CooIntegrationRequestBody, createCooIntegrationRequest } from '../../../../shared/models/coo-integration.model';
import { AccountModel } from '../../../../shared/models/loginuser.model';
import { ActiveMembershipsComponent } from "../../../../shared/components/active-memberships/active-memberships.component";
import { OptionFieldComponent } from '../../../../shared/components/controls/option-field/option-field.component';
import { FileComponent } from '../../../../shared/components/controls/file/file.component';
import { FolderResponse, AllowedDocumentType } from '../../../../shared/models/documents-response.model';
import { SkeletonLoaderComponent } from "../../../../shared/components/skeleton-loader/skeleton-loader.component";
import { LOVResponseModel } from '../../../../shared/models/lov-response.model';
import { LookupService } from '../../../../core/services/lookup.service';
import { DocumentName } from '../../../../shared/constants/documents-name.enum';
import { MarketingProductFormComponent } from "./marketing-product-form/marketing-product-form.component";
import { InformationRequestListComponent } from "./information-request-list/information-request-list.component";
import { customValidator } from '../../../../Utils/validator';
import { DcMethodValues } from '../../../../shared/constants/dc-method.constants';

@Component({
  selector: 'app-information-service',
  imports: [ReactiveFormsModule, TranslateModule, ...SHARED_COMPONENTS, SrSubmitSuccessModalComponent, ActiveMembershipsComponent, SkeletonLoaderComponent, MarketingProductFormComponent, InformationRequestListComponent],
  templateUrl: './information-service.component.html',
  styleUrl: './information-service.component.scss'
})
export class InformationServiceComponent {
  @ViewChildren('fileCmp') fileComponents!: QueryList<FileComponent>;
  @ViewChild(OptionFieldComponent) optionFieldCmp!: OptionFieldComponent;

  infoRequest = new CommonSrRequest<InformationServiceModel>();
  documentServiceType = DocumentServiceType;

  totalSteps: any = 4;
  step = 1;
  form: FormGroup;
  lang: any = "";
  membershipId: any = "";
  fieldValue = FieldValue
  lookupKey = LookupKey;
  memberships: AccountModel[] = [];
  members: any = [];
  enquiryTypes: any = [];
  letterTypes: any = [
  ];
  accountId: any = "";
  private preload: any[] = [];
  private search$ = new Subject<string>();
  loadingMember: boolean = false;
  firmType: string = "";
  showActions: boolean = true;
  userCSN: string = "";
  srDetailLoader: boolean = false;
  loadingDoc: boolean = false;
  srInprgoressAwating: boolean = false;
  showNotes: boolean = false;
  currentSrStatus: string = SrStatus.Draft;
  marketingForms: any = [];
  enablePhaseTwoChange: boolean = true;
  openMarketingProductModal: boolean = false;
  selectedProduct: any = "";
  selectedAccountServiceRequest: any = null;
  accountServiceRequests: any[] = [];
  accountServiceRequestsLoading: boolean = false;
  private lockedByAccountRequest = new Set<string>();
  private lastIsFreeMarketing: boolean = false;
  private srListSubscription?: Subscription;
  fieldVisible: boolean = true;
  private readonly blockedExporterCountryNames = [this.fieldValue.UAE, this.fieldValue.UAE_AR];

  constructor(
    private fb: FormBuilder,
    private languageService: LanguageService,
    private optionTranslateService: OptionTranslateService,
    private router: Router,
    private sharedService: SharedService,
    private api: ApiService,
    private route: ActivatedRoute,
    private lookupService: LookupService
  ) {
    this.accountId = this.sharedService.getCsnAccountId('id');
    this.userCSN = this.sharedService.getCsnAccountId('csn');

    this.lang = this.languageService.getCurrentLang();
    this.form = this.fb.group({
      membershipId: [null, [Validators.required]],
      enquiryType: [null, [Validators.required]],
      letterType: [null, [Validators.required]],
      cooNumber: ['', [customValidator('safeText')]],
      detailsConfirmed: [null, [Validators.required]],
      companyMember: [null],
      paymentMethod: [null, [Validators.required]],
      certificateLang: [null, [Validators.required]],
      companyMemberNumber: [null],
      //Form 2
      signatory: [null],
      certificateForm: [null],
      address: [null],
      buyer: ['', [Validators.maxLength(150), customValidator('english')]],
      invoiceNumber: ['', [Validators.maxLength(50), customValidator('english')]],
      exporterCountry: [null, [this.exporterCountryValidator()]],
      certificateOfOriginNumber: ['', [Validators.maxLength(15), customValidator('numberOnly')]],
      certificateOfOriginDate: this.fb.group({
        day: [null],
        month: [null],
        year: [null],
      }),
      invoiceDate: this.fb.group({
        day: [null],
        month: [null],
        year: [null],
      }),
      productList: [''],
      searchProductText: [''],
      owner: [null]
    });

    this.lastIsFreeMarketing = this.isFreeMarketing;
    this.form.get('certificateForm')?.valueChanges.subscribe(() => {
      this.updateMarketingValidators();
    });
    this.form.get('certificateOfOriginNumber')?.valueChanges.subscribe(() => {
      this.updateMarketingValidators();
    });


    this.sharedService.getSrNumber(this.route).subscribe(srNumber => {
      if (srNumber) {
        this.srDetailLoader = true;
        this.srNumber = srNumber;
        this.step = 2;
      }
    });
    // in case of draft
    if (sessionStorage.getItem("srNumber") && this.srNumber == "") {
      let storeSrNumber: any = sessionStorage.getItem("srNumber");
      this.srNumber = storeSrNumber;
      this.step = 2;
    }
    this.getInquiryType();

    //only for Member
    if (this.sharedService.getPrimaryAccount()['Account Type Code'] == UserType.MEMBER) {
      this.getActiveMembership();
      if (this.memberships.length < 1) {
        this.sharedService.toastMessage('INFO', 'NO_ACTIVE_MEMBERSHIP', 'info');
        this.router.navigate([RoutesPath.DASHBOARD]);
        return;
      }
    } else {
      this.membershipId = this.userCSN;
      this.proceedToNext();
    }
    this.openFolder();
  }
  selectMembershipError: boolean = false;
  // This method is used to get active membership
  getActiveMembership() {
    this.membershipId = this.userCSN;
    let accounts: any = Utils.checkIsArray(this.sharedService.getUserProfile()?.Account);
    const filteredAccounts = accounts.filter((acc: any) => {
      // must have CSN
      if (!acc.CSN || acc.CSN.trim() === '') {
        return false;
      }
      // must not be inactive
      if (this.sharedService.isInactiveMemberAccount(acc)) {
        return false;
      }
      // must not have Offshore License
      let accountLicenseType = acc["DC License Type"];
      if (accountLicenseType == FieldValue.OFFSHORE_LICENSE
        || accountLicenseType == FieldValue.OFFSHORE_LICENSE_AR) {
        return false;
      }
      // use common method for membership expiry validation
      return Utils.isMembershipValid(acc["DC Expiry Date"]);
    });

    this.memberships = filteredAccounts;

    if (filteredAccounts && filteredAccounts.length == 1) {
      let member = filteredAccounts.find((m: any) => m.CSN == this.userCSN);
      if (member) {
        if (this.userCSN || this.membershipId) {
          this.submitSRData(this.form.getRawValue(), SrActionType.DRAFT);
          this.form.get('membershipId')?.setValue(this.membershipId);
          this.getMemberDetail();
          this.step = 2;
        }
      }
    }
    if (!this.srNumber) {
      if (!(filteredAccounts?.find((m: any) => m.CSN == this.userCSN))) {
        this.membershipId = "";
        this.userCSN = "";
      }
    }
  }
  // This method is used to set selected member ship using member
  setSelectedMemberShip(member: any) {
    this.membershipId = "";
    this.userCSN = "";
    // must not have Offshore License      
    if (member["DC License Type"] && member["DC License Type"] == FieldValue.OFFSHORE_LICENSE || member["DC License Type"] == FieldValue.OFFSHORE_LICENSE_AR) {
      this.sharedService.toastMessage('INFO', 'OFFSHORE_LICENSE_NOTALLOWED', 'info');
      return;
    } else {

      this.membershipId = member.CSN;
      this.userCSN = member.CSN;
      this.sharedService.setPrimaryAccount(member);
      this.form.get('membershipId')?.setValue(member.CSN);
    }
  }

  // This method is used to proceed to next
  proceedToNext() {

    if (this.membershipId) {
      this.form.get('membershipId')?.setValue(this.membershipId);
      this.step = 2;
      // Scroll to top smoothly
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      this.selectMembershipError = true;
      return;
    }
    if (this.srNumber == "") {
      this.submitSRData(this.form.getRawValue(), SrActionType.DRAFT);
      this.getMemberDetail();
    }
  }
  // This method is used to handle the on init lifecycle hook
  ngOnInit(): void {
    let types = this.optionTranslateService.getOptions('svs_enquiryTypes',
      this.lang
    );
    this.marketingForms = this.optionTranslateService.getOptions('info_marketingForm',
      this.lang
    );
    //handle member search from child 
    this.search$
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        tap((term: any) => {
          // ≤0 chars or cleared ⇒ just show preload
          if (term?.searchText && term?.searchText.length <= 0) {
            this.members = this.preload;
          }
        }),
        filter((term) => term?.searchText && term?.searchText.length > 2),
        tap(() => (this.loadingMember = true)),
        switchMap((term: any) =>
          this.getMembers(term.searchText, term.searchBy)
            .pipe(finalize(() => (this.loadingMember = false)))
        )
      )
      .subscribe((response: any) => {
        if (response && response['Error Code'] == "" && response['SiebelMessage']["DC Account Thin"]) {
          let memberData = Utils.checkIsArray(response['SiebelMessage']["DC Account Thin"]);
          this.members = memberData.map((item: any) => ({
            ...item,
            Name: this.lang === 'en' ? item["DC Name English"] : item["DC Name Arabic"],
            Value: this.lang === 'en' ? item["DC Name English"] : item["DC Name Arabic"]
          }));
        } else {
          this.members = [];
        }
      })
    this.subscribeToAccountServiceRequests();
  }

  getInquiryType() {
    this.lookupService.post<LOVResponseModel>(LookupKey.LOOKUP_URL, {
      "ProcessName": "DC Get List Of Values WF",
      "Type": LookupKey.INQUIRY_TYPE,
      "LanguageCode": this.lang == 'ar' ? 'ARA' : 'ENU',
      "ParentValue": "",
      "Sub Type": ""
    })
      .subscribe({
        next: (response: any) => {
          if (response['Error Message'] == null && response.SiebelMessage?.['List Of Values']) {
            let data = Utils.checkIsArray(response.SiebelMessage?.['List Of Values']);

            const accountType = this.sharedService.getPrimaryAccount()['Account Type Code'];
            if (accountType === UserType.NON_MEMBER || accountType === UserType.NON_MEMBER_AR) {
              // Non-member: only Company Profile
              this.enquiryTypes = data.filter((type: any) => type.Name === "Company Profile");
            } else {
              // Member: only these three types
              const allowedTypes = ["Certificate Amendment", "To whom it may concern", "Company Profile"];
              this.enquiryTypes = data.filter((type: any) => allowedTypes.includes(type.Name));
            }
            if (this.srNumber) {
              this.getSRDetail();
              this.step = 2;
            }
          }
        },
        error: (e) => {
        }
      });
  }

  // This method is used to get selected member using name
  getSelectedMember(name: string = "") {
    if (!name) {
      return;
    }
    this.getMembers(name, 'MemberName')
      .pipe(finalize(() => (this.loadingMember = false)))
      .subscribe((response: any) => {
        if (response && response['Error Code'] == "" && response['SiebelMessage']["DC Account Thin"]) {
          let memberData = Utils.checkIsArray(response['SiebelMessage']["DC Account Thin"]);

          this.members = memberData.map((item: any) => ({
            ...item,
            Name: this.lang === 'en' ? item["DC Name English"] : item["DC Name Arabic"],
            Value: this.lang === 'en' ? item["DC Name English"] : item["DC Name Arabic"]
          }));

          this.preload = this.members;
        } else {
          this.members = [];
        }
      });

  }

  // This method is used to get members using term and search by
  getMembers(term: string = "", searchBy: string = "") {
    return this.sharedService.getDCAllMembers(term, searchBy);
  }
  // This method is used to calculate form progress
  get formProgress() {
    if (this.form.disabled) {
      return 100;
    }
    if (!this.form.invalid) {
      if (!this.checkRequiredDocuments()) {
        return 100;
      }
    }
    return Utils.calculateFormProgress(this.step, this.totalSteps)
  }

  // This method is used to toggle required using condition and controls
  private toggleRequired(condition: boolean, controls: string[]): void {
    Utils.addRemoveValidation(this.form, condition, controls);
  }

  private exporterCountryValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const rawValue = control.value;
      const value =
        typeof rawValue === 'string'
          ? rawValue
          : rawValue?.Value ?? rawValue?.Name ?? '';

      const normalizedValue = value.toString().trim();
      return this.blockedExporterCountryNames.includes(normalizedValue)
        ? { exporterCountryUaeNotAllowed: true }
        : null;
    };
  }

  private updateMarketingValidators(): void {
    const certificateForm = this.form.get('certificateForm')?.value;
    const isCertificateOne = certificateForm === 'Certificate-1';
    const isCertificateTwo = certificateForm === 'Certificate-2';
    const requireMarketingFields = isCertificateOne || isCertificateTwo;

    this.toggleRequired(this.isFreeMarketing, [
      'certificateForm'
    ]);
    this.toggleRequired(requireMarketingFields, [
      'buyer',
      'invoiceNumber',
      'productList'
    ]);
    this.toggleRequired(requireMarketingFields, [
      'invoiceDate.day',
      'invoiceDate.month',
      'invoiceDate.year'
    ]);
    this.toggleRequired(isCertificateTwo, ['exporterCountry']);

    const certificateOfOriginNumber = this.form.get('certificateOfOriginNumber')?.value;
    const hasCooNumber = !!(certificateOfOriginNumber && certificateOfOriginNumber.toString().trim());
    this.toggleRequired(hasCooNumber, [
      'certificateOfOriginDate.day',
      'certificateOfOriginDate.month',
      'certificateOfOriginDate.year'
    ]);
  }

  private updateSignatoryRequired(): void {
    const letterType = this.form.get('letterType')?.value;
    const isAuthorizedSignatory =
      letterType === FieldValue.AUTHORIZED_SIGNATORY_CERTIFICATE ||
      letterType === FieldValue.AUTHORIZED_SIGNATORY_CERTIFICATE_AR;
    this.toggleRequired(isAuthorizedSignatory, ['signatory']);
  }

  private updateOwnerRequired(): void {
    const letterType = this.form.get('letterType')?.value;
    const isOwnerPartner =
      letterType === FieldValue.LETTER_TYPE_OWNER_PARTNER ||
      letterType === FieldValue.LETTER_TYPE_OWNER_PARTNER_AR;
    this.toggleRequired(isOwnerPartner, ['owner']);
  }

  private updateCertificateLanguageForLetterType(): void {
    const certificateLangControl = this.form.get('certificateLang');
    if (!certificateLangControl) {
      return;
    }

    if (this.isFreeMarketing) {
      certificateLangControl.setValue(this.lang == 'ar' ? FieldValue.CERTIFICATE_LANG_AR : FieldValue.CERTIFICATE_LANG_EN, { emitEvent: false });
      if (!certificateLangControl.disabled) {
        certificateLangControl.disable({ emitEvent: false });
      }
      return;
    }

    if (certificateLangControl.disabled && !this.lockedByAccountRequest.has('certificateLang')) {
      certificateLangControl.enable({ emitEvent: false });
    }
  }

  private resetFreeMarketingFields(): void {
    this.form.patchValue({
      certificateForm: null,
      buyer: '',
      invoiceNumber: '',
      exporterCountry: null,
      certificateOfOriginNumber: '',
      certificateOfOriginDate: {
        day: null,
        month: null,
        year: null
      },
      invoiceDate: {
        day: null,
        month: null,
        year: null
      }
    }, { emitEvent: false });
    this.products = [];
    this.selectedItems = [];
    this.updateProductListControl();
    this.form.get('searchProductText')?.setValue('', { emitEvent: false });
    this.parentSrId = "";
    this.selectedAccountServiceRequest = null;
    this.resetAccountRequestFieldLocking();
  }

  // This method is used to handle letter type change event using option
  onLetterTypeChange(option: any) {
    if (!option?.selectedLov) {
      return;
    }
    this.form.get('cooNumber')?.setValue('');
    this.form.get('companyMember')?.setValue(null);
    this.toggleRequired((option?.selectedLov.Name == FieldValue.INFORMATION_LETTER_TYPE_COO_BY_DC ? true : false), ['cooNumber']);
    this.toggleRequired((option?.selectedLov.Name == FieldValue.COMPANY_PROFILE || option?.selectedLov.Name == FieldValue.COMPANY_PROFILE_AR ? true : false), ['companyMember']);

    // For Outside freezone need address required
    if (this.enablePhaseTwoChange) {
      this.toggleRequired((option?.selectedLov.Name == FieldValue.LOCATION_OUTSIDE_FREEZONE ? true : false), ['address']);
    }
    if (option?.selectedLov.Name == FieldValue.LOCATION_OUTSIDE_FREEZONE && this.isMemberFreezone) {
      this.sharedService.toastMessage(
        'INFO',
        'FREEZONE_COMPANY_NOT_ALLOWED',
        'info',
        true
      )
      this.form.get('letterType')?.setValue(null);
      this.updateCertificateLanguageForLetterType();
      return;
    }
    if (this.memberStreetAddress && option?.selectedLov.Name == FieldValue.LOCATION_OUTSIDE_FREEZONE) {
      this.form.get('address')?.setValue(this.memberStreetAddress);
    }
    this.updateDocumentVisibility();
    this.getMemberSignatory();
    this.resetFreeMarketingFields();
    this.updateMarketingValidators();
    this.updateSignatoryRequired();
    this.updateOwnerRequired();
    this.updateCertificateLanguageForLetterType();
    this.lastIsFreeMarketing = this.isFreeMarketing;
  }

  srFolder!: FolderResponse;
  mainFromSectionDocs: AllowedDocumentType[] = [];
  visibleDocumentTypes: AllowedDocumentType[] = [];

  // This method is used to get documents
  openFolder() {
    this.loadingDoc = true;
    let isLabels = !this.srNumber;
    this.sharedService.getDocuments(this.srNumber, DocumentServiceType.INFORMATION_SERVICE, isLabels)
      .subscribe({
        next: (response: any) => {
          if (response.success == true) {
            this.loadingDoc = false;
            this.srFolder = response.data ? response.data : response;
            this.updateDocumentVisibility();
          } else {
            this.sharedService.toastMessage("error", response.message, 'error');
          }
        }
      });
  }

  private updateDocumentVisibility(): void {
    if (!this.srFolder?.allowedDocumentTypes) {
      this.visibleDocumentTypes = [];
      this.mainFromSectionDocs = [];
      return;
    }

    const selectedLetterType = this.form.get('letterType')?.value;

    const hideOriginalCoo = selectedLetterType === FieldValue.AMENDMENT_TRADE_NAME_CERTIFICATE;

    const isAuthorizedSignatory =
      selectedLetterType === FieldValue.AUTHORIZED_SIGNATORY_CERTIFICATE ||
      selectedLetterType === FieldValue.AUTHORIZED_SIGNATORY_CERTIFICATE_AR;

    const isFreeMarketing =
      selectedLetterType === FieldValue.FREE_MARKETING_CERTIFICATE ||
      selectedLetterType === FieldValue.FREE_MARKETING_CERTIFICATE_AR;

    const isCOObyDC =
      selectedLetterType === FieldValue.INFORMATION_LETTER_TYPE_COO_BY_DC ||
      selectedLetterType === FieldValue.INFORMATION_LETTER_TYPE_COO_BY_DC_AR;

    this.visibleDocumentTypes = this.srFolder.allowedDocumentTypes.filter((doc: AllowedDocumentType) => {
      if (!doc) return false;
      // Hide INFO_COMPANY_REQUEST_LETTER COO if yes
      if (
        isCOObyDC &&
        (doc.nameEn === DocumentName.INFO_Invoice ||
          doc.nameEn === DocumentName.INFO_COMPANY_REQUEST_LETTER)
      ) {
        // doc.mandatory = false;
        return false;
      }
      // Hide original COO if yes
      if (hideOriginalCoo && doc.nameEn === DocumentName.INFO_Invoice) {
        doc['mandatory'] = false;
        return false;
      }

      // If Authorized Signatory hide INFO_Invoice
      if (isAuthorizedSignatory && doc.nameEn === DocumentName.INFO_Invoice) {
        doc['mandatory'] = false;
        return false;
      }

      //If Free Marketing Certificate make Invoice mandatory
      if (doc.nameEn === DocumentName.INFO_Invoice) {
        if (isFreeMarketing) {
          doc['mandatory'] = true;
        } else {
          doc['mandatory'] = false;
        }
      }

      return true;
    });

    this.mainFromSectionDocs = this.visibleDocumentTypes.filter(
      (doc: AllowedDocumentType) => !doc.forUISection
    );
  }

  // This method is used to check required documents
  checkRequiredDocuments(): boolean {
    // If there are no docs to check, nothing is missing
    if (!this.mainFromSectionDocs || this.mainFromSectionDocs.length === 0) {
      return false;
    }
    // Company Profile does not require documents
    if (this.form.get('enquiryType')?.value ==
      FieldValue.COMPANY_PROFILE || this.form.get('enquiryType')?.value == FieldValue.COMPANY_PROFILE_AR) {
      return false;
    }

    const fileCmps = this.fileComponents && typeof this.fileComponents.toArray === 'function'
      ? this.fileComponents.toArray()
      : [];

    // ViewChildren not ready or not fully rendered yet – defer document checks
    if (fileCmps.length < this.mainFromSectionDocs.length) {
      return false;
    }

    let hasMissing = false;
    for (let index = 0; index < this.mainFromSectionDocs.length; index++) {
      const doc = this.mainFromSectionDocs[index];
      const cmp = fileCmps[index];
      // Safety guard; should not happen due to length check above
      if (!cmp) continue;

      if (typeof cmp.checkMissing === 'function' && cmp.checkMissing((doc)?.mandatory)) {
        hasMissing = true;
      }
    }
    return hasMissing;
  }
  // This method is used to get letter types based on enquiry type
  getLetterTypes(option: any) {
    if (!option?.selectedLov) {
      return;
    }
    this.showCooNumberError = false;
    const wasFreeMarketing = this.lastIsFreeMarketing;
    this.form.get('letterType')?.setValue(null);
    this.form.get('cooNumber')?.setValue('');
    this.form.get('companyMember')?.setValue(null);
    this.updateCertificateLanguageForLetterType();

    this.toggleRequired((option?.selectedLov.value == FieldValue.COMPANY_PROFILE || option?.selectedLov.value == FieldValue.COMPANY_PROFILE_AR ? true : false), ['companyMember']);
    this.updateDocumentVisibility();

    this.getProductsForEnquiry(option?.selectedLov.Name);
    if (wasFreeMarketing && !this.isFreeMarketing) {
      this.resetFreeMarketingFields();
    }
    this.updateMarketingValidators();
    this.lastIsFreeMarketing = this.isFreeMarketing;
    if (this.form.get('enquiryType')?.value == FieldValue.ENQUIRY_TYPE_CERTIFICATE_AMENDMENT ||
      this.form.get('enquiryType')?.value == FieldValue.ENQUIRY_TYPE_CERTIFICATE_AMENDMENT_AR) {
      this.fieldVisible = false;
    } else {
      this.fieldVisible = true;
    }
  }

  // This method is used to get products for enquiry using enquiry type value
  getProductsForEnquiry(enquiryTypeValue: any) {
    let requestPayload = {
      "body": {
        "ProcessName": "DC Get Product Details Web WF",
        "DC Channel": this.lang == 'ar' ? FieldValue.CHANEL_ONLINE_AR : FieldValue.CHANEL_ONLINE_EN,
        "DC Method": DcMethodValues.INFORMATION_SERVICE,
        "Category": enquiryTypeValue,
        "IOName": "DCInternalProdLiteWebIO"
      }
    }
    this.api.post(
      ApiRoot.DCCICPIntegration,
      ApiEndPoints.RUN_PROCESS,
      requestPayload
    ).subscribe({
      next: (response: any) => {
        if (response.SiebelMessage && response.SiebelMessage["DC Internal Product Lite BC"]) {
          this.letterTypes = [...Utils.checkIsArray(response.SiebelMessage["DC Internal Product Lite BC"])];
        }
      }
    })
  }

  selectedItems: any = []
  // This method is used to handle add item event using items
  onAddItem(items: any) {
    if (items.length > 0) {
      this.selectedItems = items;
      this.form.get('productList')?.setValue(items);
      this.form.get('productList')?.updateValueAndValidity();
    }
  }
  // This method is used to handle remove item event using items
  onRemoveItem(items: any) {
    if (items.length < 1) {
      this.selectedItems = items;
      this.form.get('productList')?.setValue('');
    }
  }

  // This method is used to goto add business
  gotoAddBusiness() {
    this.router.navigate([`${RoutesPath.SERVICE}/${RoutesPath.ADD_MORE_BUSINESS}`]);
  }

  // This method is used to move to the next step
  nextStep(): void {
    if (this.showSelectSrToAmendmentError) {
      return;
    }
    let fields = ['membershipId', 'enquiryType', 'letterType', 'cooNumber', 'companyMember', 'certificateLang',
      'certificateForm', 'signatory', 'address', 'owner', 'buyer', 'invoiceNumber', 'exporterCountry',
      'certificateOfOriginNumber', 'productList',
      'invoiceDate.day', 'invoiceDate.month', 'invoiceDate.year',
      'certificateOfOriginDate.day', 'certificateOfOriginDate.month', 'certificateOfOriginDate.year',
      'paymentMethod', 'detailsConfirmed']
    const stepTwoFields =
      this.step === 2
        ? fields
        : [];

    const stepThreeFields =
      this.step === 3
        ? fields
        : [];

    if (!environment.ignoreValidators) {
      if (
        stepTwoFields.length > 0 &&
        stepTwoFields.some((f) => this.form.get(f)?.invalid)
      ) {
        stepTwoFields.forEach((f) => this.form.get(f)?.markAsTouched());
        return;
      }

      if (
        stepThreeFields.length > 0 &&
        stepThreeFields.some((f) => this.form.get(f)?.invalid)
      ) {
        stepThreeFields.forEach((f) => this.form.get(f)?.markAsTouched());
        const invalidControls = Utils.getInvalidControls(this.form);
        this.form.markAllAsTouched();
        console.warn('Invalid controls:', invalidControls);
        this.sharedService.toastMessage('ERROR', "FILL_REQUIRED_FIELDS_DOCUMENTS", 'error', false);
        return;
      }
    }
    if (this.form.get('letterType')?.value == FieldValue.COMPANY_PROFILE
      || this.form.get('letterType')?.value == FieldValue.COMPANY_PROFILE_AR
    ) {
      if (this.step >= 2) {
        this.submitSRData(this.form.getRawValue(), SrActionType.SUBMIT);
      }
    } else {
      if (this.step >= 3) {
        this.submitSRData(this.form.getRawValue(), SrActionType.SUBMIT);
      }
    }
    if (this.step < 3) {
      this.step++;
    }

  }

  // This method is used to save and close
  saveAndClose(): void {
    if (this.showSelectSrToAmendmentError) {
      return;
    }
    this.submitSRData(this.form.getRawValue(), SrActionType.SAVE);
  }

  get showSaveAndCloseAction(): boolean {
    return this.sharedService.canShowSaveAndClose(this.currentSrStatus);
  }

  formSubmitLoader: boolean = false;
  isSaved: boolean = false;
  srNumber: any = "";
  successModal: boolean = false;

  // This method is used to handle search using membername, number and license number
  handleSearch(searchText: string) {
    this.search$.next(searchText);
  }

  showCooNumberError: boolean = false;
  cooIntegrationList: any = [];
  // This method is used to get list of coo
  getListOfCOO() {
    this.showCooNumberError = false;
    let cooField = this.form.get("cooNumber") ?? this.form.get("certificateOfOriginNumber");
    if (!cooField?.value || !this.userCSN) {
      return;
    }

    let requestPayload: CooIntegrationRequestBody = createCooIntegrationRequest(this.userCSN, cooField?.value);

    this.api.post(
      ApiRoot.DCCICPIntegration,
      ApiEndPoints.GET_COO_LIST,
      requestPayload
    ).subscribe({
      // This method is used to handle the next callback using response
      next: (response: any) => {
        if (response?.SiebelMessage && response['Error Code'] != "1") {
          this.cooIntegrationList = response.SiebelMessage["DC COO SR Thin BC"];
          let cooNumExist = this.cooIntegrationList.find((c: any) => c["DC COO Number"] == cooField?.value);
          if (!cooNumExist) {
            this.showCooNumberError = true;
            cooField?.setValue("");
          }
        } else {
          cooField?.setValue("");
          this.showCooNumberError = true;
        }
      },
      // This method is used to handle the error callback
      error: () => {
        this.showCooNumberError = true;
        cooField?.setValue("");
      }
    })
  }

  updateMemberNuber(option: any) {
    if (option.selectedLov && option.selectedLov.CSN) {
      this.form.get('companyMemberNumber')?.setValue(option.selectedLov.CSN);
    } else {
      this.form.get('companyMemberNumber')?.setValue("");
    }
  }

  // This method is used to get sr detail
  getSRDetail() {
    if (!this.srNumber) {
      return;
    }
    this.noAdvancePaymentBalance = false;
    const requestPayload = {
      "body": {
        "ProcessName": "DC Get SR Details Web WF",
        "DC Channel": this.lang == 'ar' ? FieldValue.CHANEL_ONLINE_AR : FieldValue.CHANEL_ONLINE_EN,
        "DC Method": DcMethodValues.INFORMATION_SERVICE,
        "SR Number": this.srNumber,
        "IOName": SrIOName.INFORMATION_SERVICE
      }
    };
    this.api.post(
      ApiRoot.DCCICPIntegration,
      ApiEndPoints.GET_SR_DETAIL,
      requestPayload
    ).subscribe({
      next: (response: any) => {
        if (response["Error Code"] == "" && response["Error Message"] == "" && response?.SiebelMessage["DC Mem SR"]) {
          let serviceRequest = response?.SiebelMessage["DC Mem SR"];
          let fsCharge: any = Utils.checkIsArray(serviceRequest["FS Charge Web"]);
          this.form.get('membershipId')?.setValue(this.userCSN);
          //remove vat 5%
          let filtered = fsCharge?.filter(
            (item: any) => item["Product Name"] !== "VAT 5%"
          )
          this.srNumber = serviceRequest["SR Number"];
          this.currentSrStatus = String(serviceRequest["Status"] ?? SrStatus.Draft).trim();
          this.accountId = serviceRequest["Account Id"];
          this.userCSN = serviceRequest["CSN"];
          this.srId = serviceRequest["SR Id"];
          if (filtered && filtered.length > 0) {

            const dcCOODate = serviceRequest['DC Info COO Date']
              ? new Date(serviceRequest['DC Info COO Date'])
              : "";

            const dcInvoiceDate = serviceRequest['DC Invoice Date']
              ? new Date(serviceRequest['DC Invoice Date'])
              : "";
            this.form.patchValue({
              enquiryType: filtered[0]["DC Product Type Portal"],
              letterType: filtered[0]["Product Name"],
              companyMember: filtered[0]["DC Company Name"],
              cooNumber: serviceRequest["DC COO Number"], //filtered[0]["DC COO Number"],
              paymentMethod: serviceRequest["DC Payment Method"] ? serviceRequest["DC Payment Method"] : null,
              certificateLang: serviceRequest["DC Language"] ? serviceRequest["DC Language"] : null,
              detailsConfirmed: "Yes",
              companyMemberNumber: filtered[0]["Description"],
              address: serviceRequest['DC Account Area'],
              certificateForm: serviceRequest['DC Marketing Certificate'],
              invoiceNumber: serviceRequest['DC Invoice Number'],
              buyer: serviceRequest['DC Buyer'],
              exporterCountry: serviceRequest['DC Exporter Country'],
              certificateOfOriginDate: {
                day: dcCOODate ? dcCOODate.getDate().toString().padStart(2, '0') : null,
                month: dcCOODate ? Number(dcCOODate.getMonth() + 1).toString().padStart(2, '0') : null,
                year: dcCOODate ? dcCOODate.getFullYear() : null,
              },
              invoiceDate: {
                day: dcInvoiceDate ? dcInvoiceDate.getDate().toString().padStart(2, '0') : null,
                month: dcInvoiceDate ? Number(dcInvoiceDate.getMonth() + 1).toString().padStart(2, '0') : null,
                year: dcInvoiceDate ? dcInvoiceDate.getFullYear() : null,
              },
              certificateOfOriginNumber: serviceRequest['DC Marketing Certificate'] && serviceRequest["DC COO Number"] ? serviceRequest["DC COO Number"] : ''
            })

            let enqType = this.enquiryTypes?.find((e: any) => e.Value == filtered[0]["DC Product Type Portal"])
            if (enqType) {
              this.getProductsForEnquiry(enqType?.Name);
            }
            this.getSelectedMember(filtered[0]["DC Company Name"]);

            if (serviceRequest['DC Internal Product Clone']) {
              let marketingProduct = Utils.checkIsArray(serviceRequest['DC Internal Product Clone']);
              marketingProduct?.map((p: any, index) => {
                let prodObj = {
                  id: index + 1,
                  masterProductId: p['Id'],
                  kindOfGoods: p['DC Kind of Goods'],
                  countryOfOrigin: p['DC Country of Origin'],
                  productHSCode: p['DC HS Code']
                }
                this.products.push(prodObj);
              })
              this.form.get('productList')?.setValue(this.products);
            }

            this.parentSrId = serviceRequest["DC Parent SR Id"] ? serviceRequest["DC Parent SR Id"] : "";
            if (this.parentSrId && enqType?.Name == FieldValue.ENQUIRY_TYPE_CERTIFICATE_AMENDMENT) {
              this.updateAccountRequestFieldLocking();
            }
          }

          if (this.form.get('letterType')?.value) {
            this.toggleRequired((this.form.get('letterType')?.value == FieldValue.INFORMATION_LETTER_TYPE_COO_BY_DC || this.form.get('letterType')?.value == FieldValue.INFORMATION_LETTER_TYPE_COO_BY_DC_AR ? true : false), ['cooNumber']);
            this.toggleRequired((this.form.get('letterType')?.value == FieldValue.COMPANY_PROFILE || this.form.get('letterType')?.value == FieldValue.COMPANY_PROFILE_AR ? true : false), ['companyMember']);
            this.getMemberSignatory();
            this.updateMarketingValidators();
            this.updateSignatoryRequired();
            this.updateOwnerRequired();
            this.updateCertificateLanguageForLetterType();
            this.lastIsFreeMarketing = this.isFreeMarketing;
          }

          let memSRRelationsship = serviceRequest['DC Mem SR Relationship'];
          if (memSRRelationsship) {
            //selected owner
            if (this.form.get('letterType')?.value == FieldValue.LETTER_TYPE_OWNER_PARTNER
              || this.form.get('letterType')?.value == FieldValue.LETTER_TYPE_OWNER_PARTNER_AR
              && memSRRelationsship['Account Membership Id']) {
              this.form.get('owner')?.setValue(memSRRelationsship['Account Membership Id']);
            }
            // selected authorised signatory
            if (this.form.get('letterType')?.value == FieldValue.AUTHORIZED_SIGNATORY_CERTIFICATE
              || this.form.get('letterType')?.value == FieldValue.AUTHORIZED_SIGNATORY_CERTIFICATE_AR
              && memSRRelationsship['DC Signatory Name Super User (Eng)']) {
              this.form.get('signatory')?.setValue(memSRRelationsship['DC Signatory Name Super User (Eng)']);
            }
          }

          if (this.sharedService.enableNotesOption(this.currentSrStatus)) {
            this.srInprgoressAwating = true;
            this.showNotes = true;
          }

          if (this.currentSrStatus != SrStatus.Draft && this.currentSrStatus != SrStatus.AwaitingClarification) {
            this.showActions = false;
            this.form.disable(); // disables all fields in the form
          }

          this.updateDocumentVisibility();
          this.step = 3;
          this.srDetailLoader = false;
        } else {
          this.srDetailLoader = false;
          this.sharedService.toastMessage('ERROR', '', 'error', response["Error Message"]);
        }
      }
    })

  }

  srId: any = "1-12345";
  errorMsg: any = "";
  technicalErrorMsg: boolean = false;
  parentSrId: string = "";
  // This method is used to submit sr data using form data and action type
  submitSRData(formData: any, actionType: string) {
    this.errorMsg = "";
    let isActionSubmit = actionType == SrActionType.SUBMIT;
    let isActionSave = actionType == SrActionType.SAVE;
    let isActionDraft = actionType == SrActionType.DRAFT;
    const defaultShowActions = this.showActions;
    const restoreFormState = () => {
      this.showActions = defaultShowActions;
      this.form.enable({ emitEvent: false });
      this.updateAccountRequestFieldLocking();
      this.formSubmitLoader = false;
    };
    if (Utils.hasMaxLengthError(this.form)) {
      this.form.markAllAsTouched();
      return;
    }
    if (isActionSubmit) {
      if (this.checkRequiredDocuments() || this.noAdvancePaymentBalance) {
        this.sharedService.toastMessage('ERROR', "FILL_REQUIRED_FIELDS_DOCUMENTS", 'error', false);
        return;
      }
      if (this.form.invalid) {
        this.sharedService.toastMessage('ERROR', "FILL_REQUIRED_FIELDS_DOCUMENTS", 'error', false);
        return;
      }
      if(this.loadingDoc){
        return;
      }
    }
    let accountId = this.accountId;
    this.infoRequest.body.SiebelMessage = new SiebelMessage<InformationServiceModel>();
    this.infoRequest.body.SiebelMessage.IntObjectName = SrIOName.INFORMATION_SERVICE;
    this.infoRequest.body.SiebelMessage.MessageId = Utils.generateUniqueId();
    this.infoRequest.body.DCMethod = isActionSubmit ? 'SUBMIT' : 'SAVEASDRAFT';

    let cooDate = formData.certificateOfOriginDate.day ?
      `${formData.certificateOfOriginDate.month}/${formData.certificateOfOriginDate.day}/${formData.certificateOfOriginDate.year}` : '';
    let invoiceDate = formData.invoiceDate.day ?
      `${formData.invoiceDate.month}/${formData.invoiceDate.day}/${formData.invoiceDate.year}` : '';


    let DCMemSR: any = {
      "SR Sub Type": ServiceName.INFORMATION_SERVICES,
      "SR Type": ServiceName.INFORMATION_SERVICES,
      "Account Id": accountId,
      "DC Firm Type": this.sharedService.getPrimaryAccount()?.["Firm Type"] || "",
      "DC COO Number": formData.cooNumber ? formData.cooNumber : (formData.certificateOfOriginNumber ? formData.certificateOfOriginNumber : ""),
      "SR Id": this.srId,
      "SR Number": this.srNumber ?? "",
      "DC Channel": this.lang == 'ar' ? FieldValue.CHANEL_ONLINE_AR : FieldValue.CHANEL_ONLINE_EN,
      "DC Payment Method": formData.paymentMethod ? formData.paymentMethod : "",
      "DC Language": formData.certificateLang ? formData.certificateLang : "",
      "DC Account Area": formData.address && formData.letterType == this.fieldValue.LOCATION_OUTSIDE_FREEZONE ? formData.address : "",

      "DC Marketing Certificate": formData.certificateForm ? formData.certificateForm : "",
      "DC Invoice Number": formData.invoiceNumber ? formData.invoiceNumber : "",
      "DC Buyer": formData.buyer ? formData.buyer : "",
      "DC Exporter Country": formData.exporterCountry ? formData.exporterCountry : "",
      "DC Info COO Date": formData.certificateOfOriginDate ? cooDate : "",
      "DC Parent SR Id": this.parentSrId ? this.parentSrId : "",
      "DC Invoice Date": invoiceDate ? invoiceDate : ""
    }
    let informationMemberNumber = formData.letterType == (FieldValue.COMPANY_PROFILE || formData.letterType == FieldValue.COMPANY_PROFILE_AR)
      ? (formData.companyMemberNumber ? formData.companyMemberNumber : this.userCSN)
      : ""
    // only for company  profile 

    if (formData.letterType) {
      DCMemSR["ListOfFS Charge Web"] = {
        "FS Charge Web": [
          {
            "DC Company Name": formData.companyMember ? formData.companyMember : "",
            "DC Product Type Portal": formData.enquiryType ? formData.enquiryType : "",
            "Product Name": formData.letterType ? formData.letterType : "",
            "Charge Id": new Date().getTime().toString(), //unique id
            "Description": informationMemberNumber //formData.letterType == FieldValue.COMPANY_PROFILE || formData.letterType == FieldValue.COMPANY_PROFILE_AR ? this.userCSN : "" // only for company  profile
          }
        ]
      }
    }

    //Authorised Signatory
    if (formData.signatory) {
      let signatory: any = this.singatoryList?.find((s: any) => s["DC Related Party Name English"] == formData?.signatory);
      DCMemSR["ListOfDC Mem SR Relationship"] = {
        "DC Mem SR Relationship": [
          {
            "DC Signatory Name Super User (Eng)": signatory ? signatory["DC Related Party Name English"] : "",
            "DC Signatory Name Super User (Arabic)": signatory ? signatory["DC Related Party Name Arabic"] : ""
          }
        ]
      }
    }

    //Marketing Certificate Products
    let certificateProduct: any = [];
    if (this.products && this.products.length > 0 && this.isFreeMarketing) {
      this.products.map((p: any) => {
        let prod = {
          "Id": p.masterProductId ? p.masterProductId : "",
          "DC Kind of Goods": p.kindOfGoods ? p.kindOfGoods : '',
          "DC Country of Origin": p.countryOfOrigin ? p.countryOfOrigin : '',
          "DC HS Code": p.productHSCode ? p.productHSCode : ''
        }
        certificateProduct.push(prod)
      })

      DCMemSR["ListOfDC Internal Product Clone"] = {
        "DC Internal Product Clone": certificateProduct
      }
    }

    //Owner/partner
    if (this.form.get("owner")?.value) {
      const ownerPartnerPayload = this.getOwnerPartnerPayload();
      if (ownerPartnerPayload) {
        DCMemSR["ListOfDC Mem SR Relationship"] = {
          "DC Mem SR Relationship": [ownerPartnerPayload]
        }
      }
    }
    //end owner/partner

    this.infoRequest.body.SiebelMessage["ListOfDCMemSRIO"] = {
      "DC Mem SR": DCMemSR
    };
    if (!isActionDraft) {
      this.showActions = false;
      this.form.disable({ emitEvent: false });
      this.formSubmitLoader = true;
    }
    this.technicalErrorMsg = false;
    this.api.post(
      ApiRoot.DCCICPIntegration,
      ApiEndPoints.CREATE_UPDATE_SR,
      this.infoRequest
    ).subscribe({
      next: (response: any) => {
        if ((response['Error Code'] == "" || response['Error Code'] == "DC-VAL-ERR")
          && response["Error Message"] == null || response["Error Message"] == ""
          && response["SR Number"]) {
          this.isSaved = true;
          if (isActionSave || isActionDraft) {
            if (isActionDraft && this.srNumber == "") {
              this.srNumber = response["SR Number"];
              this.srId = response['SRId'];
              sessionStorage.setItem("srNumber", response["SR Number"]);
              this.openFolder();
            } else {
              this.srNumber = response["SR Number"];
              if (isActionSave) {
                this.successModal = true;
              }
            }
          } else {
            this.srNumber = response["SR Number"];
            let lang: any = this.sharedService.getCurrentLang();

            const { service, serviceAr } = Utils.getServiceLabels(ServiceName.INFORMATION_SERVICES, lang);
            let srDetailObj = {
              serviceSubTypeEn: service,
              serviceSubTypeAr: serviceAr,
              service: ServiceName.INFORMATION_SERVICES,
              IOName: SrIOName.INFORMATION_SERVICE,
              srNumber: this.srNumber,
              totalSteps: this.totalSteps,
              step: this.step + 1
            }
            this.sharedService.setSrResponse(srDetailObj);

            this.sharedService.toastMessage('SUCCESS', 'REQUEST_SUBMITTED', 'success');
            sessionStorage.removeItem("srNumber");
            this.router.navigate([`${RoutesPath.SERVICE}/${RoutesPath.SUCCESS_PAGE + "/" + this.srNumber}`]);
          }

          restoreFormState();

        } else {
          restoreFormState();
          if (response['Error Code'] == 'DC-VAL-ERR' && response["Error Message"] != "") {
            this.errorMsg = response['Error Message'];
          } else {
            this.technicalErrorMsg = true;
          }
        }
      },
      error: () => {
        restoreFormState();
        this.technicalErrorMsg = true;
      }
    })
  }
  // This method is used to determine if deactivate
  canDeactivate(): boolean {
    return this.sharedService.confirmNavigationIfFormDirty(this.form, this.isSaved);
  }

  // This method is used to close success modal
  closeSuccessModal() {
    this.successModal = false;
    sessionStorage.removeItem("srNumber");
    this.router.navigate([RoutesPath.DASHBOARD]);
  }

  // This method is used to handle the on destroy lifecycle hook
  ngOnDestroy(): void {
    sessionStorage.removeItem("srNumber");
    this.srListSubscription?.unsubscribe();
  }
  // This method is used to handel file event using document and document field
  handelFileEvent(document: any, documentField: any) {

  }
  // This method is used to handle payment method change event using option
  noAdvancePaymentBalance: boolean = false;
  onPaymentMethodChange(value: any) {
    this.noAdvancePaymentBalance = false;
    const selectedValue = value;
    if (selectedValue === FieldValue.PAYMENT_METHOD_ADVANCE_FOR_SERVICES || selectedValue === FieldValue.PAYMENT_METHOD_ADVANCE_FOR_SERVICES_AR) {
      this.noAdvancePaymentBalance = !this.sharedService.hasSufficientAdvanceForServicesBalance();
    } else {
      this.noAdvancePaymentBalance = false;
    }
  }

  singatoryList: any = [];
  loadingSignatory = false;
  // This method is used to get signatory gov entity using csn
  getMemberSignatory() {
    const selectedLetterType = this.form.get('letterType')?.value;
    const isAuthorizedSignatory =
      selectedLetterType === FieldValue.AUTHORIZED_SIGNATORY_CERTIFICATE ||
      selectedLetterType === FieldValue.AUTHORIZED_SIGNATORY_CERTIFICATE_AR;

    const isOwnerPartner =
      selectedLetterType === FieldValue.LETTER_TYPE_OWNER_PARTNER ||
      selectedLetterType === FieldValue.LETTER_TYPE_OWNER_PARTNER_AR;

    let accountType = this.sharedService.getPrimaryAccount()['Account Type Code'];
    if (isOwnerPartner) {
      this.getMemberDetail();
    }

    if (!isAuthorizedSignatory && !(accountType == UserType.MEMBER || accountType == UserType.MEMBER_AR)) {
      return;
    }
    let requestPayload = {
      "body": {
        "ProcessName": "DC Get List of Signatory Mob App WF",
        "IncomingHierarchy": {
          "MessageId": Utils.generateUniqueId(),
          "IntObjectName": "DCGetSignatoryIO",
          "MessageType": "Integration Object",
          "IntObjectFormat": "Siebel Hierarchical",
          "ListOfDCGetSignatoryIO": {
            "Account": {
              "CSN": this.userCSN
            }
          }
        },
        "SR Sub Type": ServiceName.INFORMATION_SERVICES
      }
    }
    this.loadingSignatory = true;
    this.api.post<any, any>(
      ApiRoot.DCCICPIntegration,
      ApiEndPoints.AUTHENTICATE_CERTIFICATE, // ApiEndPoints.VERIFY_SIGNATURE : ApiEndPoints.AUTHENTICATE_CERTIFICATE,
      requestPayload
    ).subscribe({
      next: (response: any) => {
        if (response?.SiebelMessage && response['Error Code'] == null) {
          this.loadingSignatory = false;
          let account = Utils.checkIsArray(response?.SiebelMessage['Account']);
          this.singatoryList = account[0]['Party Relationship To'];
        }
      },
      error: () => {
        this.loadingSignatory = false;
        this.singatoryList = [];
      }
    })
  }

  get isFreeMarketing() {
    let freeMarkeing: boolean = false;
    if ((this.form.get('enquiryType')?.value == FieldValue.ENQUIRY_TYPE_CERTIFICATE_AMENDMENT ||
      this.form.get('enquiryType')?.value == FieldValue.ENQUIRY_TYPE_CERTIFICATE_AMENDMENT_AR)
      ||
      (this.form.get('enquiryType')?.value == FieldValue.ENQUIRY_TYPE_WHOM_MAY_CONCERN ||
        this.form.get('enquiryType')?.value == FieldValue.ENQUIRY_TYPE_WHOM_MAY_CONCERN_AR)
    ) {

      if (FieldValue.FREE_MARKETING_CERTIFICATE.includes(this.form.get('letterType')?.value) ||
        FieldValue.FREE_MARKETING_CERTIFICATE_AR.includes(this.form.get('letterType')?.value)) {
        freeMarkeing = true;
      }
    }
    return freeMarkeing;
  }

  get showSelectSrToAmendmentError(): boolean {
    const enquiryType = this.form.get('enquiryType')?.value;
    return (
      (!this.parentSrId &&
        this.isFreeMarketing &&
        enquiryType === FieldValue.ENQUIRY_TYPE_CERTIFICATE_AMENDMENT) ||
      enquiryType === FieldValue.ENQUIRY_TYPE_CERTIFICATE_AMENDMENT_AR
    );
  }

  onAccountServiceRequestSelected(row: any) {
    this.selectedAccountServiceRequest = row;
    this.parentSrId = row['SR Id'];
    this.fieldVisible = true;
    const requestPayload = {
      "body": {
        "ProcessName": "DC Get SR Details Web WF",
        "DC Channel": this.lang == 'ar' ? FieldValue.CHANEL_ONLINE_AR : FieldValue.CHANEL_ONLINE_EN,
        "DC Method": DcMethodValues.INFORMATION_SERVICE,
        "SR Number": row['SR Number'],
        "IOName": SrIOName.INFORMATION_SERVICE
      }
    };
    this.api.post(
      ApiRoot.DCCICPIntegration,
      ApiEndPoints.GET_SR_DETAIL,
      requestPayload
    ).subscribe({
      next: (response: any) => {
        if (response["Error Code"] == "" && response["Error Message"] == "" && response?.SiebelMessage["DC Mem SR"]) {
          this.products = [];
          let serviceRequest = response?.SiebelMessage["DC Mem SR"];
          const dcCOODate = serviceRequest['DC Info COO Date']
            ? new Date(serviceRequest['DC Info COO Date'])
            : "";

          const dcInvoiceDate = serviceRequest['DC Invoice Date']
            ? new Date(serviceRequest['DC Invoice Date'])
            : "";
          this.form.patchValue({
            // enquiryType: filtered[0]["DC Product Type Portal"],
            // letterType: filtered[0]["Product Name"],
            // companyMember: filtered[0]["DC Company Name"],
            // cooNumber: filtered[0]["DC COO Number"],
            paymentMethod: serviceRequest["DC Payment Method"] ? serviceRequest["DC Payment Method"] : null,
            certificateLang: serviceRequest["DC Language"] ? serviceRequest["DC Language"] : null,
            detailsConfirmed: "Yes",
            // companyMemberNumber: filtered[0]["Description"],
            address: "",
            certificateForm: serviceRequest['DC Marketing Certificate'],
            invoiceNumber: serviceRequest['DC Invoice Number'],
            buyer: serviceRequest['DC Buyer'],
            exporterCountry: serviceRequest['DC Exporter Country'],
            certificateOfOriginDate: {
              day: dcCOODate ? dcCOODate.getDate().toString().padStart(2, '0') : null,
              month: dcCOODate ? Number(dcCOODate.getMonth() + 1).toString().padStart(2, '0') : null,
              year: dcCOODate ? dcCOODate.getFullYear() : null,
            },
            invoiceDate: {
              day: dcInvoiceDate ? dcInvoiceDate.getDate().toString().padStart(2, '0') : null,
              month: dcInvoiceDate ? Number(dcInvoiceDate.getMonth() + 1).toString().padStart(2, '0') : null,
              year: dcInvoiceDate ? dcInvoiceDate.getFullYear() : null,
            },
            certificateOfOriginNumber: serviceRequest["DC COO Number"]
          })
          this.updateAccountRequestFieldLocking();
          if (serviceRequest['DC Internal Product Clone']) {
            let marketingProduct = Utils.checkIsArray(serviceRequest['DC Internal Product Clone']);
            marketingProduct?.map((p: any, index) => {
              let prodObj = {
                id: index + 1,
                masterProductId: p['Id'],
                kindOfGoods: p['DC Kind of Goods'],
                countryOfOrigin: p['DC Country of Origin'],
                productHSCode: p['DC HS Code']
              }
              this.products.push(prodObj);
            })
            this.form.get('productList')?.setValue(this.products);
          }
        } else {
          this.srDetailLoader = false;
          this.sharedService.toastMessage('ERROR', '', 'error', response["Error Message"]);
        }
      }
    })
  }

  changeSelectedAccountServiceRequest() {
    this.parentSrId = "";
    this.selectedAccountServiceRequest = null;
    this.products = [];
    this.form.get('productList')?.setValue('');
    this.resetAccountRequestFieldLocking();
  }

  private updateAccountRequestFieldLocking(): void {
    const hasValue = (value: any) =>
      value != null && value !== '' && !(typeof value === 'string' && value.trim() === '');
    const hasDateValue = (groupValue: any) =>
      !!(groupValue?.day || groupValue?.month || groupValue?.year);

    const lockIfValue = (controlName: string, shouldLock: boolean) => {
      const ctl = this.form.get(controlName);
      if (!ctl || !shouldLock || ctl.disabled) {
        return;
      }
      ctl.disable({ emitEvent: false });
      this.lockedByAccountRequest.add(controlName);
    };

    lockIfValue('certificateLang', hasValue(this.form.get('certificateLang')?.value));
    lockIfValue('certificateForm', hasValue(this.form.get('certificateForm')?.value));
    lockIfValue('invoiceNumber', hasValue(this.form.get('invoiceNumber')?.value));
    lockIfValue('buyer', hasValue(this.form.get('buyer')?.value));
    lockIfValue('exporterCountry', hasValue(this.form.get('exporterCountry')?.value));
    lockIfValue('invoiceDate', hasDateValue(this.form.get('invoiceDate')?.value));
    lockIfValue('certificateOfOriginNumber', hasValue(this.form.get('certificateOfOriginNumber')?.value));
    lockIfValue('certificateOfOriginDate', hasDateValue(this.form.get('certificateOfOriginDate')?.value));
  }

  private resetAccountRequestFieldLocking(): void {
    this.lockedByAccountRequest.forEach((controlName) => {
      const ctl = this.form.get(controlName);
      if (ctl?.disabled) {
        ctl.enable({ emitEvent: false });
      }
    });
    this.lockedByAccountRequest.clear();
  }

  private subscribeToAccountServiceRequests(): void {
    this.srListSubscription?.unsubscribe();
    const enquiryTypeControl = this.form?.get('enquiryType');
    if (!enquiryTypeControl) {
      return;
    }
    this.srListSubscription = enquiryTypeControl.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe(() => this.loadAccountServiceRequests());
    this.loadAccountServiceRequests();
  }

  private shouldLoadAccountServiceRequests(): boolean {
    const enquiryType = this.form.get('enquiryType')?.value;
    const isCertificateAmendment =
      enquiryType === FieldValue.ENQUIRY_TYPE_CERTIFICATE_AMENDMENT ||
      enquiryType === FieldValue.ENQUIRY_TYPE_CERTIFICATE_AMENDMENT_AR;

    return isCertificateAmendment;
  }

  loadAccountServiceRequests() {
    if (!this.shouldLoadAccountServiceRequests()) {
      return
    }
    const requestPayload = {
      "body": {
        "ProcessName": "DC Get Account Service Request List WF",
        "DC Channel": this.lang == 'ar' ? FieldValue.CHANEL_ONLINE_AR : FieldValue.CHANEL_ONLINE_EN,
        "DC Method": DcMethodValues.INFORMATION_SERVICE,
        "Account Id": this.accountId
      }
    };
    this.accountServiceRequestsLoading = true;
    this.api.post(
      ApiRoot.DCCICPIntegration,
      ApiEndPoints.RUN_PROCESS,
      requestPayload
    ).subscribe({
      next: (response: any) => {
        this.accountServiceRequestsLoading = false;
        const srList = Utils.checkIsArray(
          response?.SiebelMessage?.['DC Mem SR']
        );
        this.accountServiceRequests = srList;
        this.selectedAccountServiceRequest = this.accountServiceRequests?.find(sr => sr['SR Id'] === this.parentSrId) || null;

      },
      error: () => {
        this.accountServiceRequestsLoading = false;
        this.accountServiceRequests = [];
      }
    });
  }

  get isMemberFreezone() {
    return this.sharedService.getPrimaryAccount()?.['DC License Category'] == "Freezone" ? true : false;
  }
  openAddProductModal() {
    this.selectedProduct = "";
    this.openMarketingProductModal = true;
  }
  editProduct(item: any) {
    this.selectedProduct = item;
    this.openMarketingProductModal = true;
  }
  removeProduct(item: any) {
    this.products = this.products.filter((p: any) => p.id !== item.id);
    this.updateProductListControl();
  }

  onProductFormSubmit(event: any) {
    if (!event) {
      return;
    }
    if (event.type === 'update' && event.product) {
      this.products = this.products.map((p: any) =>
        p.id === event.product.id ? event.product : p
      );
    } else if (event.type === 'add' && event.products) {
      const incoming = Array.isArray(event.products) ? event.products : [];
      const existingMap = new Map(this.products.map((p: any) => [p.id, p]));
      incoming.forEach((p: any) => {
        if (!p) return;
        const productId = p.id || Utils.generateUniqueId();
        existingMap.set(productId, { ...p, id: productId });
      });
      this.products = Array.from(existingMap.values());
    }
    this.updateProductListControl();
    this.selectedProduct = "";
    this.openMarketingProductModal = false;
  }

  private updateProductListControl() {
    this.form.get('productList')?.setValue(this.products.length > 0 ? this.products : '');
    this.form.get('productList')?.updateValueAndValidity();
  }
  products: any[] = [];
  currentPage: number = 1;
  pageSize: number = 4;

  get filteredProducts() {
    const term = this.form.get("searchProductText")?.value?.toString().trim().toLowerCase();
    if (!term) {
      return this.products;
    }
    return this.products.filter((p: any) =>
      (p.kindOfGoods?.toLowerCase().includes(term)) ||
      (p.productHSCode?.toLowerCase().includes(term)) ||
      (p.countryOfOrigin?.Value?.toLowerCase().includes(term)) ||
      (typeof p.countryOfOrigin === 'string' && p.countryOfOrigin.toLowerCase().includes(term))
    );
  }

  get paginatedProducts() {
    const start = (this.currentPage - 1) * this.pageSize;
    return this.filteredProducts.slice(start, start + this.pageSize);
  }

  get totalPages() {
    return Math.ceil(this.filteredProducts.length / this.pageSize);
  }

  loadPage(page: number) {
    this.currentPage = page;
  }

  search() {
    this.currentPage = 1;
  }
  listOfOwnerParters: any = [];
  ownerLoading: boolean = false;
  memberStreetAddress: string = "";
  // This method is used to get owner/partner list using csn
  getMemberDetail() {
    if (!this.userCSN) {
      return;
    }
    this.ownerLoading = true;
    this.listOfOwnerParters = [];
    let requestPayload = {
      "body": {
        "ProcessName": "DC Get Member Details Web WF",
        "DC Channel": this.lang == 'ar' ? FieldValue.CHANEL_ONLINE_AR : FieldValue.CHANEL_ONLINE_EN,
        "DC Method": DcMethodValues.INFORMATION_SERVICE,
        "IOName": "DC Get Acc Details IO",
        "CSN": this.userCSN
      }
    }
    this.api.post(ApiRoot.DCCICPIntegration, ApiEndPoints.GET_MEMBER_DETAIL_BY_CSN, requestPayload)
      .subscribe({
        next: (response: any) => {
          if (response["Error Code"] == "" && response["Error Message"] == "") {
            this.ownerLoading = false;
            const serviceRequest = response.SiebelMessage?.["DC Account Data Transfer"];
            //Update address-area for outside freezone
            let cutAddress: any = "";
            if (serviceRequest["CUT Address"]) {
              let memberAddress = Utils.checkIsArray(serviceRequest["CUT Address"]);
              cutAddress = memberAddress ? memberAddress[0] : null;
              this.memberStreetAddress = cutAddress ? (cutAddress['Street Address 4'] ? cutAddress['Street Address 4'] : '') : "";

              if (this.memberStreetAddress && this.form.get('letterType')?.value == FieldValue.LOCATION_OUTSIDE_FREEZONE && !this.form.get('address')?.value) {
                this.form.get('address')?.setValue(this.memberStreetAddress);
              }
            }

            if (serviceRequest['Party Relationship To']) {
              const allowedTypes = ['Owner', 'Owner/Partner', 'Partners', 'Partner', 'Est. Owner', 'Shares Owner'];
              let partyRelationship = Utils.checkIsArray(serviceRequest['Party Relationship To']);
              const relationships = partyRelationship?.filter((relationship: any) => allowedTypes.includes(relationship['Relationship Type']));

              this.listOfOwnerParters = relationships;
            }
          } else {
            this.ownerLoading = false;
          }
        }
      })
  }

  getOwnerPartnerPayload(): any | null {
    const ownerRowId = this.form.get('owner')?.value;

    if (!ownerRowId) {
      return null;
    }

    const selectedOwner = this.listOfOwnerParters
      ?.find((owner: any) => owner['Row Id'] === ownerRowId);

    if (!selectedOwner) {
      return null;
    }

    const currentYear = new Date().getFullYear();

    return {
      "Relationship": selectedOwner["Relationship Type"] || "",

      "DC Main Phone": selectedOwner["DC Mobile Number"] || "",

      "Member DOB": selectedOwner["Member DOB"] || "",

      "DC Emirates ID Number":
        selectedOwner["DC Emirates ID Number"] || "",

      "DC National ID":
        selectedOwner["DC Contact National Id"] || null,

      "DC Ownership Percent":
        selectedOwner["DC Ownership Percent"] || "",

      "DC Relationship Type":
        selectedOwner["Related Party Type"] === "Company"
          ? "Organization"
          : "Contact",

      "DC Member Relationship":
        selectedOwner["Relationship Type"] || "",

      "DC PP Exp Date":
        selectedOwner["DC PP Exp Date"] || "",

      "UAE Citizen":
        selectedOwner["UAE Citizen"] || "No",

      "DC Contact Name(ARABIC)":
        selectedOwner["Related Party Contact Name Ara"] || "",

      "DC Contact Name(ENGLISH)":
        selectedOwner["Related Party Contact Name Eng"] || "",

      "DC Name(ENGLISH)":
        selectedOwner["DC Name(ENGLISH)"] || "",

      "DC Name(ARABIC)":
        selectedOwner["DC Name(ARABIC)"] || "",

      "DC Cell Phone":
        selectedOwner["DC Mobile Number"] || "",

      "Membership Year":
        currentYear.toString(),

      "DC DED Partner Passport Number":
        selectedOwner["DC DED Partner Passport Number"] || "",

      "DC Contact Nationality":
        selectedOwner["DC Cust Nationality"] || "",

      "DC Email Address":
        selectedOwner["DC Email Address"] || "",

      "DC DED PartnerNationalityCode": "",

      "DC Authorized Signatory":
        selectedOwner["DC Authorized Signatory"] || "N",

      "DC Job Title":
        selectedOwner["DC Job Title"] || "",

      "DC End Date": "",

      "Account Membership Id":
        selectedOwner["Row Id"] || ""
    };
  }

}
